import {
	reCharacteristicConstants
}from "./constants"
import actions from '../../../actions'

const initialState = {
	isSending  : false,
	list       : [],
	changed    : null,
	paged      : {},
	pagedAudit : {}
}

export default function (state = initialState, action){
	switch (action.type){
		case reCharacteristicConstants.GetList.REQUEST:
		case reCharacteristicConstants.GetPaged.REQUEST:
		case reCharacteristicConstants.GetPagedAll.REQUEST:
		case reCharacteristicConstants.GetPagedAudit.REQUEST:
		case reCharacteristicConstants.Create.REQUEST:
		case reCharacteristicConstants.Delete.REQUEST:
		case reCharacteristicConstants.Restore.REQUEST:
		case reCharacteristicConstants.Update.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case reCharacteristicConstants.GetList.FAILURE:
		case reCharacteristicConstants.GetPaged.FAILURE:
		case reCharacteristicConstants.GetPagedAll.FAILURE:
		case reCharacteristicConstants.GetPagedAudit.FAILURE:
		case reCharacteristicConstants.Create.FAILURE:
		case reCharacteristicConstants.Delete.FAILURE:
		case reCharacteristicConstants.Restore.FAILURE:
		case reCharacteristicConstants.Update.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case reCharacteristicConstants.GetPaged.SUCCESS:
		case reCharacteristicConstants.GetPagedAll.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case reCharacteristicConstants.GetPagedAudit.SUCCESS:
			return {
				...state,
				isSending  : false,
				pagedAudit : action.payload.result
			}
		case reCharacteristicConstants.GetList.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case reCharacteristicConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case reCharacteristicConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case reCharacteristicConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result.id ? actions.update : null
			}
		case reCharacteristicConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case reCharacteristicConstants.Clear:
			return {
				...state,
				isSending  : false,
				list       : [],
				changed    : null,
				paged      : {},
				pagedAudit : {}
			}
		default:
			return state
	}
}